import * as React from 'react';
import { Button, Table, Panel, ButtonGroup, Row, Col } from 'react-bootstrap';
import { IBasicOrderInfo, IOrderRow, OrderTypes } from '../Types';
import { Translate } from '../../../../../shared/LanguageService';
import ProductSelect from './ProductSelect';
import OrderRow from './OrderRow';
import * as Features from '../../../../../shared/Features';

interface IProps {
    order: IBasicOrderInfo;
    selectedProduct: number;
    onChange: (e: any) => void;
    remove: (orderRow: IOrderRow) => void;
    add: () => void;
    edit: (id: number) => void;
    user: any;
    orderId: number;
}

const OrderRowList = (props: IProps) => {
    return (
        <Col sm={12}>
            <Panel>
                <Panel.Heading>
                    <h3 className="panel-title">
                        {Translate('view-order/basic-order-info/panel-headers/products')}
                    </h3>
                </Panel.Heading>
                <Panel.Body>
                    <Table responsive>
                        <thead>
                            <tr className="table_header">
                                <th>
                                    {Translate(
                                        'view-order/basic-order-info/products/table-headers/name'
                                    )}{' '}
                                </th>
                                {(props.order.orderType & OrderTypes.photo) > 0 && <th></th>}
                                {Features.hasFeature(
                                    Features.ViewProductPriceBrokerFirm,
                                    props.user
                                ) && (
                                    <th className="text-center">
                                        {Translate(
                                            'view-order/basic-order-info/products/table-headers/customer-price'
                                        )}
                                    </th>
                                )}
                                {Features.hasFeature(
                                    Features.ViewPhotographerCompensation,
                                    props.user
                                ) &&
                                    (props.order.orderType & OrderTypes.photo) > 0 && (
                                        <th className="text-center">
                                            {Translate(
                                                'view-order/basic-order-info/products/table-headers/compensation'
                                            )}
                                        </th>
                                    )}
                                {Features.hasFeature(
                                    Features.ProductPricePropertyOwner,
                                    props.user
                                ) && (
                                    <th className="text-center">
                                        {Translate(
                                            'view-order/basic-order-info/products/table-headers/owner-price'
                                        )}
                                    </th>
                                )}
                                <th className="text-center">
                                    {Translate(
                                        'view-order/basic-order-info/products/table-headers/number-of-units'
                                    )}
                                </th>
                                <th className="text-center">
                                    {Translate(
                                        'view-order/basic-order-info/products/table-headers/invoice-status'
                                    )}
                                </th>
                                {(Features.hasFeature(Features.ViewInvoiceComment, props.user) ||
                                    Features.hasFeature(
                                        Features.ViewPhotographerComment,
                                        props.user
                                    )) && (
                                    <th className="text-center">
                                        {Translate(
                                            'view-order/basic-order-info/products/table-headers/comments'
                                        )}
                                    </th>
                                )}

                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {props.order.orderRows
                                .sort((a, b) => a.id - b.id)
                                .filter((orderRow) => {
                                    if (
                                        Features.hasFeature(
                                            Features.HideRemovedOrderRows,
                                            props.user
                                        ) === true &&
                                        orderRow.removed === true
                                    ) {
                                        return false;
                                    }
                                    return true;
                                })
                                .map((p: IOrderRow) => {
                                    return (
                                        <OrderRow
                                            orderType={props.order.orderType}
                                            orderId={props.orderId}
                                            orderRow={p}
                                            key={p.id}
                                            remove={props.remove}
                                            edit={props.edit}
                                            user={props.user}
                                        />
                                    );
                                })}
                        </tbody>
                    </Table>
                    {Features.hasFeature(Features.AddOrderRow, props.user) && (
                        <Row>
                            <Col sm={12} md={6}>
                                <ProductSelect
                                    onChange={props.onChange}
                                    products={props.order.customer.possibleProducts}
                                    product={props.selectedProduct}
                                />
                                <ButtonGroup>
                                    <Button
                                        bsStyle="success"
                                        onClick={props.add}
                                        disabled={props.selectedProduct < 0}
                                    >
                                        <i className="material-icons md-24">add</i>
                                        {Translate(
                                            'view-order/basic-order-info/products/button-labels/add'
                                        )}
                                    </Button>
                                </ButtonGroup>
                            </Col>
                        </Row>
                    )}
                </Panel.Body>
            </Panel>
        </Col>
    );
};

export default OrderRowList;
